import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { Collapse, List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeProductType, updateSts, loadOrificeConfigByProdTypeID } from './ProductTypeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

const { Panel } = Collapse;
export default function ProductTypeList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const ProductTypes = useSelector(
    (state: AppState) => state.ProductTypes
  );
  const fields = useSelector((state: AppState) => state.ProductTypes);

  useEffect(() => {
    if (ProductTypes.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: ProductTypes.success.data,
      });

      dispatch(updateSts({}));
    } else if (ProductTypes.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: ProductTypes.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [ProductTypes])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeProductType(id));
  };

  const onChangeCollapse = (key: any) => {
    if (key) {
      dispatch(loadOrificeConfigByProdTypeID(key));
    }
  };
  const genExtra = (data: any) => (
    <div className='first_class'>
      <div className='sub_data' style={{ marginLeft: '20px', width: '50%', color: "black" }}><b>Value:</b> {data?.type_name}</div>
      <div className='sub_data' style={{ marginLeft: '20px', width: '100%', color: "black" }}><b>Category:</b> {data?.category?.category_name}</div>
      {/* <div className='sub_data' style={{ marginLeft: '20px', width: '50%' }}><b>Orifice Size:</b> {data?.orifice_size}</div> */}
    
        <EditOutlined style={{ color: '#018B98', width: '55px', fontSize: '120%' }} onClick={() => showModal(data)} />
        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(data.id)}>
          <DeleteOutlined style={{ color: 'red', fontSize: '120%' }} />
        </Popconfirm>
    </div>
  );
  return (
    <Collapse style={{ backgroundColor: "white" }} accordion defaultActiveKey={['']} onChange={onChangeCollapse}>
      {ProductTypes?.ProductType.map(block => Appww(block))}
    </Collapse>

    /*   <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={ProductTypes?.ProductType}
        renderItem={(item: any, index) => (
          <List.Item key={item.id}
            actions={[
              <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
              <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
                <DeleteOutlined style={{ color: 'red' }} />
              </Popconfirm>]}>
  
            <div className='main_class'>
              <p className='sub_data'><b>Value: </b>{item?.type_name} </p>
            </div>
          </List.Item>
        )}
      /> */
  );
  function Appww(data: any) {
    return (
      <Panel collapsible={data?.category?.category_code == 'VALVE' ? "icon" : "disabled"} showArrow={data?.category?.category_code == 'VALVE' ? true : false} style={data?.category?.category_code != 'VALVE' ? { marginLeft: '30px' } : { marginLeft: '0px' }} header={genExtra(data)} key={data.id}>
        <List size='small'
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={fields?.OrificeConfig}
          renderItem={(item: any, index) => (
            <List.Item key={item.id} >

              <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <div style={{ marginLeft: '50px', width: '20%' }}><b>Body Size:</b> {item?.body_size} </div>
                <div style={{ marginLeft: '11px', width: '20%' }}><b>Orifice Size:</b> {item?.orifice_size}</div>
              </div>
            </List.Item>
          )}
        />
      </Panel>
    );
  }
}